<template>
    <ul class="breadcrumb">
        <li
            v-for="(item, index) in breadcrumb"
            :key="item.alias"
        >
            <router-link v-if="index < breadcrumb.length - 1" :to="item.alias">
                {{ item.title }}
            </router-link>
            <span v-else>{{ item.title }}</span>

            <svg v-if="index < breadcrumb.length - 1" class="icon arrow">
                <use xlink:href="#angle-right"></use>
            </svg>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'breadcrumb',
    props: ['pageName'],
    computed: {
        ...mapGetters({
            navigation: 'content/getNav'
        }),
        currentPath() {
            return this.$route.path;
        },
        breadcrumb() {
            const path = this.findPathInNavigation(this.navigation, this.currentPath);
            return path ? path.filter(item => item.title !== 'Übersicht') : [];
        }
    },
    methods: {
        findPathInNavigation(items, targetAlias, path = []) {
            for (const item of items) {
                const newPath = [...path, item];

                if (item.alias === targetAlias || item.internal_path === targetAlias) {
                    return newPath;
                }

                if (item.children) {
                    const result = this.findPathInNavigation(item.children, targetAlias, newPath);
                    if (result) return result;
                }
            }

            return null;
        }
    }
};
</script>

